var _taggedTemplateLiteral = require("/opt/build/repo/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _templateObject;
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("openstack-uicore-foundation", [], t) : "object" == typeof exports ? exports["openstack-uicore-foundation"] = t() : e["openstack-uicore-foundation"] = t();
}(this, function () {
  return function () {
    "use strict";

    var e = {
        4341: function _(e, t, o) {
          o.r(t), o.d(t, {
            CLEAR_SESSION_STATE: function CLEAR_SESSION_STATE() {
              return E;
            },
            LOGOUT_USER: function LOGOUT_USER() {
              return p;
            },
            RECEIVE_USER_INFO: function RECEIVE_USER_INFO() {
              return S;
            },
            REQUEST_USER_INFO: function REQUEST_USER_INFO() {
              return R;
            },
            SESSION_STATE_STATUS_CHANGED: function SESSION_STATE_STATUS_CHANGED() {
              return w;
            },
            SESSION_STATE_STATUS_ERROR: function SESSION_STATE_STATUS_ERROR() {
              return O;
            },
            SESSION_STATE_STATUS_UNCHANGED: function SESSION_STATE_STATUS_UNCHANGED() {
              return g;
            },
            SET_LOGGED_USER: function SET_LOGGED_USER() {
              return _;
            },
            UPDATE_SESSION_STATE_STATUS: function UPDATE_SESSION_STATE_STATUS() {
              return f;
            },
            UPDATE_USER_INFO: function UPDATE_USER_INFO() {
              return y;
            },
            doLogout: function doLogout() {
              return h;
            },
            getUserInfo: function getUserInfo() {
              return U;
            },
            onUserAuth: function onUserAuth() {
              return T;
            },
            updateSessionStateStatus: function updateSessionStateStatus() {
              return m;
            },
            updateUserInfo: function updateUserInfo() {
              return A;
            }
          });
          var n = o(8779),
            r = o.n(n),
            s = o(4656),
            i = o.n(s),
            a = o(4054),
            l = o(6793),
            c = o(9893);
          function u(e, t) {
            var o = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var n = Object.getOwnPropertySymbols(e);
              t && (n = n.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), o.push.apply(o, n);
            }
            return o;
          }
          function d(e) {
            for (var t = 1; t < arguments.length; t++) {
              var o = null != arguments[t] ? arguments[t] : {};
              t % 2 ? u(Object(o), !0).forEach(function (t) {
                r()(e, t, o[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : u(Object(o)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(o, t));
              });
            }
            return e;
          }
          var _ = "SET_LOGGED_USER",
            p = "LOGOUT_USER",
            R = "REQUEST_USER_INFO",
            S = "RECEIVE_USER_INFO",
            E = "CLEAR_SESSION_STATE",
            f = "UPDATE_SESSION_STATE_STATUS",
            g = "unchanged",
            w = "changed",
            O = "error",
            y = "UPDATE_USER_INFO",
            T = function T(e, t, o) {
              var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
              var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              return function (s) {
                (0, c.storeAuthInfo)(e, n, r, t), s({
                  type: _,
                  payload: {
                    sessionState: o
                  }
                });
              };
            },
            h = function h(e) {
              return function (t, o) {
                t({
                  type: p,
                  payload: {
                    backUrl: e
                  }
                });
              };
            },
            U = function U() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "groups";
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var r = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              return /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(s, u) {
                  var d, _u, _, p, E, f;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          d = (0, l.getAllowedUserGroups)();
                          d = "" !== d ? d.split(" ") : [];
                          _u = u();
                          _ = _u.loggedUserState;
                          p = _.member;
                          _context.next = 7;
                          return (0, c.getAccessToken)();
                        case 7:
                          E = _context.sent;
                          if (!(null != p)) {
                            _context.next = 10;
                            break;
                          }
                          return _context.abrupt("return", (null != n && null != o && n.push(o), Promise.resolve()));
                        case 10:
                          null == r && (r = a.authErrorHandler), s((0, a.startLoading)());
                          f = {
                            access_token: E,
                            expand: e
                          };
                          return _context.abrupt("return", (t && (f.fields = t), (0, a.getRequest)((0, a.createAction)(R), (0, a.createAction)(S), (0, l.buildAPIBaseUrl)("/api/v1/members/me"), r)(f)(s, u).then(function () {
                            s((0, a.stopLoading)());
                            var e = u().loggedUserState.member;
                            if (null == e) {
                              var _e = {
                                title: "ERROR",
                                html: i().translate("errors.user_not_set"),
                                type: "error"
                              };
                              s((0, a.showMessage)(_e, c.initLogOut));
                            }
                            if (d.length > 0) {
                              if (0 === e.groups.filter(function (e, t) {
                                return d.includes(e.code);
                              }).length) {
                                var _e2 = {
                                  title: "ERROR",
                                  html: i().translate("errors.user_not_authz"),
                                  type: "error"
                                };
                                return void s((0, a.showMessage)(_e2, c.initLogOut));
                              }
                            }
                            null != n && null != o && n.push(o);
                          })));
                        case 13:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }();
            },
            A = function A(e) {
              return function (t, o) {
                var _o = o(),
                  n = _o.loggedUserState,
                  r = n.member;
                if (null == r) throw Error("Member is not set.");
                if (e.id != r.id) throw Error("Member is not the same.");
                t({
                  type: y,
                  payload: d({}, e)
                });
              };
            },
            m = function m(e) {
              return function (t, o) {
                t({
                  type: f,
                  payload: {
                    sessionStateStatus: e
                  }
                });
              };
            };
        },
        1593: function _(e, t, o) {
          o.d(t, {
            AUTH_ERROR_ACCESS_TOKEN_EXPIRED: function AUTH_ERROR_ACCESS_TOKEN_EXPIRED() {
              return s;
            },
            AUTH_ERROR_LOCK_ACQUIRE_ERROR: function AUTH_ERROR_LOCK_ACQUIRE_ERROR() {
              return i;
            },
            AUTH_ERROR_MISSING_AUTH_INFO: function AUTH_ERROR_MISSING_AUTH_INFO() {
              return n;
            },
            AUTH_ERROR_MISSING_REFRESH_TOKEN: function AUTH_ERROR_MISSING_REFRESH_TOKEN() {
              return r;
            },
            AUTH_ERROR_REFRESH_TOKEN_REQUEST_ERROR: function AUTH_ERROR_REFRESH_TOKEN_REQUEST_ERROR() {
              return a;
            }
          });
          var n = "AUTH_ERROR_MISSING_AUTH_INFO",
            r = "AUTH_ERROR_MISSING_REFRESH_TOKEN",
            s = "AUTH_ERROR_ACCESS_TOKEN_EXPIRED",
            i = "AUTH_ERROR_LOCK_ACQUIRE_ERROR",
            a = "AUTH_ERROR_REFRESH_TOKEN_REQUEST_ERROR";
        },
        9893: function _(e, t, o) {
          o.d(t, {
            doLogin: function doLogin() {
              return I;
            },
            getAccessToken: function getAccessToken() {
              return N;
            },
            initLogOut: function initLogOut() {
              return G;
            },
            storeAuthInfo: function storeAuthInfo() {
              return v;
            }
          });
          var n = o(6793),
            r = o(8362),
            s = o.n(r);
          o(2691);
          var i = require("browser-tabs-lock");
          var l = o.n(i);
          var c = require("js-cookie");
          var u = o.n(c),
            d = o(6530),
            _ = o.n(d);
          o(3856), o(4341);
          var p = require("crypto-js/sha256");
          var R = o.n(p);
          var S = require("crypto-js/enc-base64url");
          var E = o.n(S);
          var f = require("crypto-js/enc-hex");
          var g = o.n(f);
          var w = 65536,
            O = "undefined" != typeof window ? window.crypto || window.msCrypto : null;
          var y = o(1593);
          var Lock = new (l())(),
            GET_TOKEN_SILENTLY_LOCK_KEY = "openstackuicore.lock.getTokenSilently",
            T = "code",
            h = "authInfo",
            U = "nonce",
            A = "pkce",
            m = "idToken",
            b = function b(e) {
              var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
                o = "";
              for (var _n = 0; _n < e; _n++) {
                o += t.charAt(Math.floor(Math.random() * t.length));
              }
              return o;
            },
            I = function I() {
              var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
              var i = function () {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
                var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
                var a = j(),
                  l = (0, n.getAuthCallback)(),
                  c = F(),
                  u = q(),
                  d = x();
                null != e && (l += "?BackUrl=".concat(encodeURI(e)));
                var p = b(16);
                (0, n.putOnLocalStorage)(U, p);
                var R = _()("".concat(c, "/oauth2/auth")),
                  S = {
                    response_type: encodeURI(d),
                    scope: encodeURI(u),
                    nonce: p,
                    response_mode: "fragment",
                    client_id: encodeURI(a),
                    redirect_uri: encodeURI(l)
                  };
                if (d === T) {
                  var _e3 = k();
                  (0, n.putOnLocalStorage)(A, JSON.stringify(_e3)), S.code_challenge = _e3.codeChallenge, S.code_challenge_method = "S256", S.approval_prompt = "force";
                }
                return t && (S.prompt = t), u && u.includes("offline_access") && (S.prompt = "consent"), o && (S.id_token_hint = o), r && (S.provider = r), i && (S.otp_login_hint = i), s && (S.login_hint = encodeURI(s)), R = R.query(S), R;
              }(e, o, null, t, r, s);
              (0, n.getCurrentLocation)().replace(i.toString());
            },
            k = function k() {
              var e = (0, n.base64URLEncode)(function (e) {
                if (e > 4294967295) throw new RangeError("requested too many random bytes");
                var t = Buffer.allocUnsafe(e);
                if (!O) return a;
                if (e > 0) if (e > w) for (var _o2 = 0; _o2 < e; _o2 += w) {
                  O.getRandomValues(t.slice(_o2, _o2 + w));
                } else O.getRandomValues(t);
                return t;
              }(64));
              return {
                codeVerifier: e,
                codeChallenge: function (e) {
                  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "hex";
                  var o = g();
                  return "Base64url" === t && (o = E()), R()(e).toString(o);
                }(e, "Base64url"),
                createdAt: new Date()
              };
            },
            N = /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                var _e4, _t, _o3, _n2, _r, _i, _a, _l;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return (0, n.retryPromise)(function () {
                          return Lock.acquireLock(GET_TOKEN_SILENTLY_LOCK_KEY, 6e3);
                        }, 10);
                      case 2:
                        if (_context3.sent) {
                          _context3.next = 4;
                          break;
                        }
                        throw Error(y.AUTH_ERROR_LOCK_ACQUIRE_ERROR);
                      case 4:
                        _context3.prev = 4;
                        _e4 = C();
                        if (_e4) {
                          _context3.next = 8;
                          break;
                        }
                        throw Error(y.AUTH_ERROR_MISSING_AUTH_INFO);
                      case 8:
                        _t = _e4.accessToken, _o3 = _e4.expiresIn, _n2 = _e4.accessTokenUpdatedAt, _r = _e4.refreshToken, _i = x();
                        _a = s()().unix();
                        _l = _a - _n2;
                        _o3 -= 60;
                        console.log("openstack-uicore-foundation::Security::methods::getAccessToken now ".concat(_a, " accessTokenUpdatedAt ").concat(_n2, " expiresIn ").concat(_o3));
                        _context3.t0 = _l >= _o3 || null == _t;
                        if (!_context3.t0) {
                          _context3.next = 19;
                          break;
                        }
                        console.log("openstack-uicore-foundation::Security::methods::getAccessToken  access token expired, refreshing it ...");
                        _context3.next = 18;
                        return function () {
                          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, t) {
                            var _e5, _o4, _n3, _r2, _s;
                            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                              while (1) {
                                switch (_context2.prev = _context2.next) {
                                  case 0:
                                    if (!(e === T && D())) {
                                      _context2.next = 11;
                                      break;
                                    }
                                    if (t) {
                                      _context2.next = 3;
                                      break;
                                    }
                                    throw P(), Error(y.AUTH_ERROR_MISSING_REFRESH_TOKEN);
                                  case 3:
                                    _context2.next = 5;
                                    return L(t);
                                  case 5:
                                    _e5 = _context2.sent;
                                    _o4 = _e5.access_token;
                                    _n3 = _e5.expires_in;
                                    _r2 = _e5.refresh_token;
                                    _s = _e5.id_token;
                                    return _context2.abrupt("return", (void 0 === _r2 && (_r2 = null), v(_o4, _n3, _r2, _s), _o4));
                                  case 11:
                                    throw P(), Error(y.AUTH_ERROR_ACCESS_TOKEN_EXPIRED);
                                  case 12:
                                  case "end":
                                    return _context2.stop();
                                }
                              }
                            }, _callee2);
                          }));
                          return function (_x3, _x4) {
                            return _ref3.apply(this, arguments);
                          };
                        }()(_i, _r);
                      case 18:
                        _t = _context3.sent;
                      case 19:
                        return _context3.abrupt("return", _t);
                      case 20:
                        _context3.prev = 20;
                        _context3.next = 23;
                        return Lock.releaseLock(GET_TOKEN_SILENTLY_LOCK_KEY);
                      case 23:
                        return _context3.finish(20);
                      case 24:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, null, [[4,, 20, 24]]);
              }));
              return function N() {
                return _ref2.apply(this, arguments);
              };
            }(),
            L = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
                var t, o, r, _e6, _o5, _s2, _i2, _a2, _l2;
                return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        t = F(), o = j();
                        r = {
                          grant_type: "refresh_token",
                          client_id: encodeURI(o),
                          refresh_token: e
                        };
                        _context4.prev = 2;
                        _context4.next = 5;
                        return fetch("".concat(t, "/oauth2/token"), {
                          method: "POST",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json"
                          },
                          body: JSON.stringify(r)
                        }).then(function (e) {
                          if (400 === e.status) {
                            (0, n.getCurrentPathName)();
                            throw (0, n.setSessionClearingState)(!0), Error("".concat(y.AUTH_ERROR_REFRESH_TOKEN_REQUEST_ERROR, ": ").concat(e.status, " - ").concat(e.statusText));
                          }
                          return e;
                        }).catch(function (e) {
                          throw Error("".concat(y.AUTH_ERROR_REFRESH_TOKEN_REQUEST_ERROR, ": ").concat(e.message));
                        });
                      case 5:
                        _e6 = _context4.sent;
                        _context4.next = 8;
                        return _e6.json();
                      case 8:
                        _o5 = _context4.sent;
                        _s2 = _o5.access_token, _i2 = _o5.refresh_token, _a2 = _o5.expires_in, _l2 = _o5.id_token;
                        return _context4.abrupt("return", {
                          access_token: _s2,
                          refresh_token: _i2,
                          expires_in: _a2,
                          id_token: _l2
                        });
                      case 13:
                        _context4.prev = 13;
                        _context4.t0 = _context4["catch"](2);
                        throw console.log(_context4.t0), _context4.t0;
                      case 16:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, null, [[2, 13]]);
              }));
              return function L(_x5) {
                return _ref4.apply(this, arguments);
              };
            }(),
            v = function v(e, t) {
              var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var s = C(),
                i = {
                  accessToken: e,
                  expiresIn: t,
                  accessTokenUpdatedAt: Math.floor(Date.now() / 1e3)
                };
              null == o && s && (o = s.refreshToken), null == r && s && (r = s.idToken), o && (i.refreshToken = o), r ? (i[m] = r, u().set(m, r, {
                secure: !0,
                sameSite: "Lax"
              })) : u().remove(m), (0, n.putOnLocalStorage)(h, JSON.stringify(i));
            },
            C = function C() {
              try {
                var _e7 = (0, n.getFromLocalStorage)(h, !1);
                return _e7 ? JSON.parse(_e7) : null;
              } catch (e) {
                return null;
              }
            },
            P = function P() {
              "undefined" != typeof window && ((0, n.removeFromLocalStorage)(h), u().remove(m));
            },
            H = function H() {
              if ("undefined" != typeof window) {
                var _e8 = C();
                return _e8 ? _e8.idToken : null;
              }
              return null;
            },
            j = function j() {
              return "undefined" != typeof window ? window.OAUTH2_CLIENT_ID : null;
            },
            x = function x() {
              return "undefined" != typeof window && window.OAUTH2_FLOW || "token id_token";
            },
            D = function D() {
              return "undefined" == typeof window || new Boolean(window.OAUTH2_USE_REFRESH_TOKEN || !0);
            },
            F = function F() {
              return "undefined" != typeof window ? window.IDP_BASE_URL : null;
            },
            q = function q() {
              return "undefined" != typeof window ? window.SCOPES : null;
            },
            G = function G() {
              (0, n.getCurrentLocation)().replace(function () {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                var t = F(),
                  o = j(),
                  r = _()("".concat(t, "/oauth2/end-session")),
                  s = b(16),
                  i = "".concat((0, n.getOrigin)(), "/auth/logout");
                (0, n.putOnLocalStorage)("post_logout_state", s);
                var a = {
                  post_logout_redirect_uri: encodeURI(i),
                  client_id: encodeURI(o),
                  state: s
                };
                return e && (a.id_token_hint = e), r.query(a);
              }(H()).toString());
            };
        },
        4054: function _(e, t, o) {
          o.d(t, {
            authErrorHandler: function authErrorHandler() {
              return I;
            },
            createAction: function createAction() {
              return g;
            },
            getRequest: function getRequest() {
              return k;
            },
            showMessage: function showMessage() {
              return P;
            },
            startLoading: function startLoading() {
              return w;
            },
            stopLoading: function stopLoading() {
              return O;
            }
          });
          var n = o(3838),
            r = o.n(n),
            s = o(2691),
            i = o.n(s),
            a = o(6530),
            l = o.n(a),
            c = o(271),
            u = o.n(c),
            d = o(4656),
            _ = o.n(d),
            p = o(6793),
            R = o(4341),
            S = o(9893);
          var E = ["access_token"];
          var f = i();
          var g = function g(e) {
              return function (t) {
                return {
                  type: e,
                  payload: t
                };
              };
            },
            w = (g("RESET_LOADING"), g("START_LOADING")),
            O = g("STOP_LOADING"),
            y = {},
            T = {},
            h = function h(e) {
              return 0 === Object.keys(e).length && e.constructor === Object;
            },
            U = function U(e, t, o, n) {
              return {
                httpCode: e,
                title: t,
                html: o,
                type: n
              };
            },
            A = function A(e, t, o) {
              return U(e, t, o, "error");
            },
            m = function m(e, t, o) {
              return U(e, t, o, "warning");
            },
            b = function b() {
              return function (e) {
                var t = (0, p.getCurrentPathName)(),
                  o = (0, p.isClearingSessionState)();
                e({
                  type: R.CLEAR_SESSION_STATE,
                  payload: {}
                }), o || ((0, p.setSessionClearingState)(!0), console.log("authErrorHandler 401 - re login"), (0, S.doLogin)(t));
              };
            },
            I = function I(e, t) {
              var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : P;
              return function (t) {
                var n, r;
                var s = e.status;
                var i,
                  a,
                  l = "";
                switch (t(O()), s) {
                  case 401:
                    o !== P ? (i = A(s, "ERROR", _().translate("errors.user_not_auth")), a = function a() {
                      return t(b());
                    }) : t(b());
                    break;
                  case 403:
                    i = A(s, "ERROR", _().translate("errors.user_not_authz")), a = S.initLogOut;
                    break;
                  case 404:
                    l = (null === (n = e.response.body) || void 0 === n ? void 0 : n.message) || (null === (r = e.response.error) || void 0 === r ? void 0 : r.message) || e.message, i = m(s, "Not Found", l);
                    break;
                  case 412:
                    for (var _i3 = 0, _Object$entries = Object.entries(e.response.body.errors); _i3 < _Object$entries.length; _i3++) {
                      var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
                        _t2 = _Object$entries$_i[0],
                        _o6 = _Object$entries$_i[1];
                      l += isNaN(_t2) ? "".concat(_t2, ": ") : "", l += "".concat(_o6, "<br>");
                    }
                    t({
                      type: "VALIDATE",
                      payload: {
                        errors: e.response.body.errors
                      }
                    }), i = m(s, "Validation error", l);
                    break;
                  default:
                    i = A(s, "ERROR", _().translate("errors.server_error"));
                }
                i && t(o(i, a));
              };
            },
            k = function k(e, t, o) {
              var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : N;
              var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
              var i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
              return function () {
                var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return function (c, u) {
                  var d = l()(o),
                    _ = d.toString();
                  if (!h(a)) {
                    var _e9 = a.access_token,
                      _t3 = r()(a, E);
                    _ = d.query(_t3).toString(), d = d.query(a);
                  }
                  return e && "function" == typeof e && c(e(s)), function (e) {
                    y[e] && (y[e].abort(), console.log("aborted request ".concat(e)), delete y[e]);
                  }(_), new Promise(function (e, o) {
                    var r = f.get(d.toString());
                    if (i && T.hasOwnProperty(_)) {
                      var _e10 = T[_].etag;
                      _e10 && r.set("If-None-Match", _e10);
                    }
                    r.timeout({
                      response: 6e4,
                      deadline: 6e4
                    }).end(C(c, u, t, n, e, o, _, i)), function (e, t) {
                      y[e] = t;
                    }(_, r);
                  });
                };
              };
            },
            N = function N(e, t) {
              return function (e) {
                var o = t.body,
                  n = "";
                o instanceof Object && o.hasOwnProperty("message") && (n = o.message), u().fire(t.statusText, n, "error");
              };
            },
            L = function L(e) {
              return e.toLowerCase();
            },
            v = function v(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var o = function (e) {
                return Object.keys(e);
              }(t).find(function (e) {
                return function (t) {
                  return L(t) === e;
                };
              }(e));
              return o ? t[o] : void 0;
            },
            C = function C(e, t, o, n, r, s) {
              var i = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
              var a = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : !1;
              return function (l, c) {
                if (l || !c.ok) {
                  if (304 === l.status && T.hasOwnProperty(i) && a) {
                    var _t4 = T[i].body;
                    return "function" == typeof o ? (e(o({
                      response: _t4
                    })), r({
                      response: _t4
                    })) : (e(o), r({
                      response: _t4
                    }));
                  }
                  return n && n(l, c)(e, t), s({
                    err: l,
                    res: c,
                    dispatch: e,
                    state: t
                  });
                }
                var u = c.body;
                if (a) {
                  var _e11 = v("etag", c.headers);
                  _e11 && (T[i] = {
                    etag: _e11,
                    body: u
                  });
                }
                return "function" == typeof o ? (e(o({
                  response: u
                })), r({
                  response: u
                })) : (e(o), r({
                  response: u
                }));
              };
            },
            P = function P(e) {
              var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return function (o) {
                o(O()), u().fire(e).then(function (e) {
                  e.value && "function" == typeof t && t();
                });
              };
            };
        },
        6793: function _(e, t, o) {
          o.d(t, {
            base64URLEncode: function base64URLEncode() {
              return R;
            },
            buildAPIBaseUrl: function buildAPIBaseUrl() {
              return l;
            },
            getAllowedUserGroups: function getAllowedUserGroups() {
              return a;
            },
            getAuthCallback: function getAuthCallback() {
              return n;
            },
            getCurrentLocation: function getCurrentLocation() {
              return r;
            },
            getCurrentPathName: function getCurrentPathName() {
              return i;
            },
            getFromLocalStorage: function getFromLocalStorage() {
              return u;
            },
            getOrigin: function getOrigin() {
              return s;
            },
            isClearingSessionState: function isClearingSessionState() {
              return _;
            },
            putOnLocalStorage: function putOnLocalStorage() {
              return c;
            },
            removeFromLocalStorage: function removeFromLocalStorage() {
              return d;
            },
            retryPromise: function retryPromise() {
              return S;
            },
            setSessionClearingState: function setSessionClearingState() {
              return p;
            }
          });
          o(8362), o(6530);
          var n = function n() {
              return "undefined" != typeof window ? "".concat(window.location.origin, "/auth/callback") : null;
            },
            r = function r() {
              var e = "";
              return "undefined" != typeof window && (e = window.location, window.top && (e = window.top.location)), e;
            },
            s = function s() {
              return "undefined" != typeof window ? window.location.origin : null;
            },
            i = function i() {
              return "undefined" != typeof window ? window.location.pathname : null;
            },
            a = function a() {
              return "undefined" != typeof window ? window.ALLOWED_USER_GROUPS || "" : null;
            },
            l = function l(e) {
              return "undefined" != typeof window ? "".concat(window.API_BASE_URL).concat(e) : null(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
            },
            c = function c(e, t) {
              "undefined" != typeof window && window.localStorage.setItem(e, t);
            },
            u = function u(e, t) {
              if ("undefined" != typeof window) {
                var _o7 = window.localStorage.getItem(e);
                return t && (console.log("getFromLocalStorage removing key ".concat(e)), d(e)), _o7;
              }
              return null;
            },
            d = function d(e) {
              "undefined" != typeof window && window.localStorage.removeItem(e);
            },
            _ = function _() {
              return "undefined" != typeof window && window.clearing_session_state;
            },
            p = function p(e) {
              "undefined" != typeof window && (window.clearing_session_state = e);
            },
            R = function R(e) {
              return e.toString("base64").replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
            },
            S = /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
                var t,
                  _o8,
                  _args5 = arguments;
                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        t = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : 3;
                        _o8 = 0;
                      case 2:
                        if (!(_o8 < t)) {
                          _context5.next = 10;
                          break;
                        }
                        _context5.next = 5;
                        return e();
                      case 5:
                        if (!_context5.sent) {
                          _context5.next = 7;
                          break;
                        }
                        return _context5.abrupt("return", !0);
                      case 7:
                        _o8++;
                        _context5.next = 2;
                        break;
                      case 10:
                        return _context5.abrupt("return", !1);
                      case 11:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));
              return function S(_x6) {
                return _ref5.apply(this, arguments);
              };
            }();
        },
        8779: function _(e) {
          e.exports = require("@babel/runtime/helpers/defineProperty");
        },
        3838: function _(e) {
          e.exports = require("@babel/runtime/helpers/objectWithoutProperties");
        },
        4656: function _(e) {
          e.exports = require("i18n-react/dist/i18n-react");
        },
        3856: function _(e) {
          e.exports = require("idtoken-verifier");
        },
        8362: function _(e) {
          e.exports = require("moment-timezone");
        },
        2691: function _(e) {
          e.exports = require("superagent/lib/client");
        },
        271: function _(e) {
          e.exports = require("sweetalert2");
        },
        6530: function _(e) {
          e.exports = require("urijs");
        }
      },
      t = {};
    function o(n) {
      var r = t[n];
      if (void 0 !== r) return r.exports;
      var s = t[n] = {
        exports: {}
      };
      return e[n](s, s.exports, o), s.exports;
    }
    return function () {
      o.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return o.d(t, {
          a: t
        }), t;
      };
    }(), function () {
      o.d = function (e, t) {
        for (var n in t) {
          o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
          });
        }
      };
    }(), function () {
      o.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      };
    }(), function () {
      o.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      };
    }(), o(4341);
  }();
});